export interface GroupWrapperFiltersActionProps {
  onTrash?: () => void
  onDrag?: () => void
  onRocket?: (state: boolean) => void
  onCollapse?: (state: GroupWrapperCollapseState) => void
  collapseState?: GroupWrapperCollapseState
  rocketState?: boolean
}
export enum GroupWrapperCollapseState {
  OPEN = 'open',
  CLOSED = 'closed'
}
